import React from 'react';
import '../../assets/css/case-home.css';
import type { ComponentContentSchema } from '@vibesites/runtime';
// @ts-ignore
import { useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';

export function AboutFeaturedText() {
  const label = useContentToken('aboutfeaturedtext.label');
  const title = useContentToken('aboutfeaturedtext.title');
  const ctaText = useContentToken('aboutfeaturedtext.cta_text');
  const ctaLinkText = useContentToken('aboutfeaturedtext.cta_link_text');
  const ctaUrl = useContentToken('aboutfeaturedtext.cta_url');
  const bgImage = useContentToken('aboutfeaturedtext.background_image');

  const ctaParts = (ctaText as string).split(ctaLinkText as string);

  return (
    <section className="case-aboutpage-featured">
      <div className="case-aboutpage-featured-content">
        <div className="case-aboutpage-featured-inner">
          <EditableToken
            path="aboutfeaturedtext.label"
            type="text"
            label="Section Label"
            defaultValue={contentSchema.tokens['aboutfeaturedtext.label'].defaultValue}
            as="h4"
            style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '1rem', display: 'block', color: '#fff' }}
          >
            {label}
          </EditableToken>
          <EditableToken
            path="aboutfeaturedtext.title"
            type="text"
            label="Title"
            defaultValue={contentSchema.tokens['aboutfeaturedtext.title'].defaultValue}
            as="h2"
            style={{ fontSize: '2.25rem', fontWeight: 700, lineHeight: 1.3, marginBottom: '2rem', display: 'block', color: '#fff' }}
          >
            {title}
          </EditableToken>
          <RichTextContent
            path="aboutfeaturedtext.body"
            label="Body Text"
            defaultValue={contentSchema.tokens['aboutfeaturedtext.body'].defaultValue}
            as="p"
            style={{ fontSize: '1rem', lineHeight: 1.53, marginBottom: '1rem', color: 'rgba(255,255,255,0.85)' }}
          />
          <EditableToken path="aboutfeaturedtext.cta_text" type="text" label="CTA Text" defaultValue={contentSchema.tokens['aboutfeaturedtext.cta_text'].defaultValue} as="div">
            <p style={{ fontSize: '1rem', lineHeight: 1.53, color: 'rgba(255,255,255,0.85)' }}>
              {ctaParts[0]}
                <EditableToken path="aboutfeaturedtext.cta_link_text" type="text" label="CTA Link Text" defaultValue={contentSchema.tokens['aboutfeaturedtext.cta_link_text'].defaultValue} as="span" style={{ display: 'contents' }}>
                <EditableToken path="aboutfeaturedtext.cta_url" type="url" label="CTA URL" defaultValue={contentSchema.tokens['aboutfeaturedtext.cta_url'].defaultValue} as="span" style={{ display: 'contents' }}>
                  <a href={ctaUrl} style={{ color: '#fff', textDecoration: 'underline', fontWeight: 500 }}>{ctaLinkText}</a>
                </EditableToken>
              </EditableToken>
              {ctaParts[1]}
            </p>
          </EditableToken>
        </div>
      </div>
      <div className="case-aboutpage-featured-bg">
        <EditableToken path="aboutfeaturedtext.background_image" type="image" label="Background Image" defaultValue={contentSchema.tokens['aboutfeaturedtext.background_image'].defaultValue} as="div" style={{ width: '100%', height: '100%' }}>
          <div
            className="case-aboutpage-featured-bg-img"
            style={{ backgroundImage: `url(${bgImage})` }}
          />
        </EditableToken>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AboutFeaturedText',
  displayName: 'About Featured Text',
  tokens: {
    'aboutfeaturedtext.label': {
      label: 'Section Label',
      type: 'text',
      defaultValue: 'THE CASE & ASSOCIATES WAY',
    },
    'aboutfeaturedtext.title': {
      label: 'Title',
      type: 'text',
      defaultValue: 'Caring to improve the lives of our employees and the people we serve',
    },
    'aboutfeaturedtext.body': {
      label: 'Body Text',
      type: 'richtext',
      defaultValue: 'Since 1983, Case & Associates has been redefining multifamily and commercial property management with a unique vision based on family values and superior customer service. The company was founded by Mike Case, who believed he could improve the current standards of management by bringing more of a personal touch to client relationships and company culture. His son, Scott Case, now leads the company with the same vision and is involved in every aspect of the business from maintenance to leadership. Our executive team has over 200 years of combined experience in the real estate industry. Case & Associates proudly manages over 30,000 units across six states and continues to grow.',
    },
    'aboutfeaturedtext.cta_text': {
      label: 'CTA Text',
      type: 'text',
      defaultValue: 'Search our communities and see what makes Case & Associates stand out from the rest.',
    },
    'aboutfeaturedtext.cta_link_text': {
      label: 'CTA Link Text',
      type: 'text',
      defaultValue: 'our communities',
    },
    'aboutfeaturedtext.cta_url': {
      label: 'CTA URL',
      type: 'url',
      defaultValue: '/apartments',
    },
    'aboutfeaturedtext.background_image': {
      label: 'Background Image',
      type: 'image',
      defaultValue: 'https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfd5c-7e18-76fc-a681-e057658199ce.webp',
    },
  },
};

(AboutFeaturedText as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AboutFeaturedText;
